import React from 'react'
import PropTypes from 'prop-types'
import ArrowDown from 'images/arrow-down-red.svg'

const ArrowDownRed = ({
  value,
  fontSize = 14,
  lineHeight = 17
}) => (
  <div className='flex justify-content-center '>
    {value !== '0' && <img src={ArrowDown} />}
    {value && <span style={{fontSize, lineHeight: `${lineHeight}px`, color: "#b42a27"}}  className='margin-left-extra-small red-text' > {value}% </span>}
  </div>
)

ArrowDownRed.propTypes = {
  value: PropTypes.string,
  fontSize: PropTypes.number,
  lineHeight: PropTypes.number
}

export default ArrowDownRed
